export const DELAYED_RADIO_PROCESSING = 'delayed_radio_processing';
export const MULTI_COMPANY_ACCESS = 'multi_company_access';
export const TRACKING_PURCHASES_ENABLED = 'tracking_purchases_enabled';
